import { Box, Container, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        padding: "40px 0",
        marginTop: "auto", // Aby stopka zawsze była na dole strony
      }}
    >
      <Container maxWidth="lg">
        {/* Stopka: Prawa autorskie */}
        <Box
          sx={{
            borderTop: "1px solid #c0c0c0",
            paddingTop: "25px",
            marginTop: "0px",
            textAlign: "center",
            color: "#c0c0c0",
          }}
        >
          <Typography variant="body2" sx={{ color: "#c0c0c0" }}>
            &copy; {new Date().getFullYear()} Allworks sp. z o.o.
          </Typography>
          <Typography variant="body2" sx={{ color: "#c0c0c0" }}>
            ul. Brzozowa 14D 43-190 Mikołów
          </Typography>
          <Typography variant="body2" sx={{ color: "#c0c0c0" }}>
            email: Michal.Jaskulski@allworks.pl
            <br /> tel. +48 602 209 858
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
